import React, { useState, useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import axios from "../api/axios";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import FloatingMessage from "./utilities/FloatingMessage";
// import ErrorPopUp from "./utilities/ErrorPopUp";
import LoginErrorPopUp from "./utilities/LoginErrorPopUp"
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState();
  const [message, setMessage] = useState(null);
  const [popUpText, setPopUpText] = useState(null);
  const location = useLocation();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password, rememberMe);
    if (result.success) {      
        window.location.href = location.state?.from || "/dashboard";
    } else {
      if (result.action){
        setPopUpText(result.message);
      } else {
        setError(result.error || "Login failed. Please try again.");
      }
      setLoading(false);
    }
  };
  const login = async (email, password, remember = false) => {
    try {
      // Step 1: Get CSRF cookie (required by Sanctum)
      await axios.get("/sanctum/csrf-cookie", {});
      // Step 2: Send login request
      const response = await axios.post("/login", {
        email,
        password,
        remember,
      });
      // Step 3: Return response
      return {
        success: response.data.success,
        action: response.data.action? response.data.action : "",
        message: response.data.message? response.data.message : "",
      };
    } catch (error) {
      // Handle error response from Laravel
      const message =
        error.response?.data?.message || error.message || "Login failed";
      return {
        success: false,
        error: message,
        errors: error.response?.data?.errors || null,
      };
    }
  };
  useEffect(() => {
    if (location.state?.message) {
      setMessage(location.state.message);
    }
  }, [location]);

  return (
    <>
      {
        popUpText && (
          <LoginErrorPopUp message={popUpText} open={true} onClose={()=>setPopUpText(null)} />
        )
      }
      {message && (
        <FloatingMessage message={message} onClose={() => setMessage(null)} />
      )}
      <section className="fullScreenLayout">
        <NavbarGuest />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            padding: "20px",
            flex: "1",
          }}
        >
          <div className="p-4">
            <p className="text-center login">Log In</p>
            <p className="text-center para">
              Log in with your iSort&trade; account credentials.
            </p>
            
            <form onSubmit={handleSubmit}>
            {(error) && (
                  <p className="error-text text-center" style={{maxWidth:"360px",}}>{error}</p>
                )}
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email*
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  Password*
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="form-group checkbox d-flex">
                <input
                  type="checkbox"
                  id="remember"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  style={{ width: "1rem" }}
                />
                <span htmlFor="remember">
                  &nbsp;Remember me
                </span>
              </div>
              <button
                type="submit"
                className="btn w-100 text-white"
                style={{ backgroundColor: "#0061BB" }}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>

            <div className="mt-3 text-center">
              <Link to="/forgotpassword" className="text-secondary">
                Forgot your password?
              </Link>
            </div>
            <div className="text-center mt-2 text-secondary">
              <span>Don't have an account? </span>
              <Link to="/register" className="text-secondary">
                Register
              </Link>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}
